import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBuildingBlock24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconBuildingBlock24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 5.5H7a.5.5 0 0 0-.5.5v1h3V6a.5.5 0 0 0-.5-.5M5 6v1a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3V6a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1h-2V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2m9.5 1h3V6a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5zM13 8.5H5A1.5 1.5 0 0 0 3.5 10v7A1.5 1.5 0 0 0 5 18.5h14a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 19 8.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBuildingBlock24);
